import { useAPI, useAPIMutation } from '@/api/api';
import { IFVipInfoRsp } from '@/api/apiRsp/IFVipRsp';

type EmptyProps = Record<string, never>;

/**
 * 获取Vip信息
 */
export function useVipInfo(revalidateOnMount = true) {
  const { data, error, isLoading, isValidating, revalidate, mutate } = useAPI<IFVipInfoRsp, EmptyProps>(
    { path: '/api/vip/my', type: 'get', needLogin: true },
    null,
    { dedupingInterval: 60000, revalidateOnMount: revalidateOnMount }
  );

  return {
    data,
    isLoading,
    isValidating,
    error,
    revalidate,
    mutate,
  };
}

/**
 * 获取个人中心信息
 */
// export function useDroplist(revalidateOnMount = true) {
//   const { data, error, isLoading, isValidating, revalidate } = useAPI<IFVipInfoRsp, EmptyProps>(
//     { path: '/api/vip/my', type: 'get', needLogin: true },
//     null,
//     { dedupingInterval: 0, revalidateOnMount: revalidateOnMount }
//   );

//   return {
//     data,
//     isLoading,
//     isValidating,
//     error,
//     revalidate,
//   };
// }
